import { render, staticRenderFns } from "./VideoViewer.vue?vue&type=template&id=6ac3638a&scoped=true&"
import script from "./VideoViewer.vue?vue&type=script&lang=js&"
export * from "./VideoViewer.vue?vue&type=script&lang=js&"
import style0 from "./VideoViewer.vue?vue&type=style&index=0&id=6ac3638a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3638a",
  null
  
)

export default component.exports